export default "__VITE_ASSET__DVVNA$cy__"